import type { TovVersionResponse } from "contracts/api/client-tov/version.responses";
import { TOV_BOUNDARY_TYPES } from "contracts/enums/tov-voice";
import { For } from "solid-js";
import { TOV_FIELD_KIND } from "../../enums/tov";
import {
  type CardEditProps,
  EditableCard,
  EditableRow,
  type FieldSpec,
} from "./EditForms";
import { Group } from "./Group";
import { CardGrid, StrengthBar } from "./primitives";

const TRAIT_FIELDS: FieldSpec[] = [
  { name: "key", label: "Key", kind: TOV_FIELD_KIND.TEXT },
  { name: "label", label: "Label", kind: TOV_FIELD_KIND.TEXT },
  {
    name: "description",
    label: "Description",
    kind: TOV_FIELD_KIND.TEXT,
    grow: true,
  },
  { name: "targetStrength", label: "Strength", kind: TOV_FIELD_KIND.NUMBER },
];

const BOUNDARY_FIELDS: FieldSpec[] = [
  {
    name: "boundaryType",
    label: "Type",
    kind: TOV_FIELD_KIND.SELECT,
    options: TOV_BOUNDARY_TYPES,
  },
  { name: "text", label: "Text", kind: TOV_FIELD_KIND.TEXT, grow: true },
];

export function TraitCards(props: {
  version: TovVersionResponse;
  edit: CardEditProps;
}) {
  return (
    <Group title="Traits" empty={props.version.traits.length === 0}>
      <CardGrid>
        <For each={props.version.traits}>
          {(trait) => (
            <EditableCard
              title={trait.label}
              tag={`${trait.targetStrength}/100`}
              editable={props.edit.editable}
              fields={TRAIT_FIELDS}
              initial={{
                key: trait.key,
                label: trait.label,
                description: trait.description,
                targetStrength: trait.targetStrength,
                displayOrder: trait.displayOrder,
              }}
              onSave={(values) => props.edit.onEdit("traits", trait.id, values)}
              onDelete={() => props.edit.onDelete("traits", trait.id)}
            >
              <StrengthBar value={trait.targetStrength} />
              <p class="tov-desc">{trait.description}</p>
              <ul class="tov-list">
                <For each={trait.boundaries}>
                  {(boundary) => (
                    <EditableRow
                      editable={props.edit.editable}
                      fields={BOUNDARY_FIELDS}
                      initial={{
                        boundaryType: boundary.boundaryType,
                        text: boundary.text,
                        displayOrder: boundary.displayOrder,
                      }}
                      onSave={(values) =>
                        props.edit.onEdit("boundaries", boundary.id, values)
                      }
                      onDelete={() =>
                        props.edit.onDelete("boundaries", boundary.id)
                      }
                    >
                      <span class="tov-chip muted">
                        {boundary.boundaryType}
                      </span>{" "}
                      {boundary.text}
                    </EditableRow>
                  )}
                </For>
              </ul>
            </EditableCard>
          )}
        </For>
      </CardGrid>
    </Group>
  );
}
